import { render, staticRenderFns } from "./CreateMaintenance.vue?vue&type=template&id=54631142&scoped=true"
import script from "./CreateMaintenance.vue?vue&type=script&lang=js"
export * from "./CreateMaintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54631142",
  null
  
)

export default component.exports